import { createRouter, createWebHashHistory } from "@ionic/vue-router";
import { RouteRecordRaw } from "vue-router";
import Home from "../views/Home.vue";

const routes: Array<RouteRecordRaw> = [
  {
    path: "/",
    redirect: "/home",
  },
  {
    path: "/home",
    name: "Home",
    component: Home,
  },
  {
    path: "/signup/:campaignId",
    name: "signup",
    component: () => import("@/views/SignUpView.vue"),
  },
  {
    path: "/trades/:type",
    name: "trades",
    component: () => import("@/views/TradesView.vue"),
  },
  {
    path: "/tests",
    component: () => import("@/views/TestsView.vue"),
  },
];

const router = createRouter({
  history: createWebHashHistory(process.env.BASE_URL),
  routes,
});

export default router;
